
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5.5h-21a1 1 0 00-1 1v21a1 1 0 001 1h21a1 1 0 001-1v-21a1 1 0 00-1-1z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 20.5a6 6 0 100-12 6 6 0 000 12zm11.5-14h-4.884a.979.979 0 01-.541-.168 10.988 10.988 0 00-12.15 0 .979.979 0 01-.541.168H.5m20.25-3.75a.25.25 0 110 .5.25.25 0 010-.5zm-3 0a.25.25 0 110 .5.25.25 0 010-.5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 18.5a4 4 0 100-8 4 4 0 000 8z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    